// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".Row-module-row-KZdOZ{display:grid;grid-template-columns:repeat(12, 1fr);grid-gap:var(--des-spacing-grid-layout-primary-2xl);gap:var(--des-spacing-grid-layout-primary-2xl)}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"row": "Row-module-row-KZdOZ"
};
export default ___CSS_LOADER_EXPORT___;
